// extracted by mini-css-extract-plugin
export default {"wrap":"bs-z","fullWidth":"cs-z","items":"ds-z","featureCss":"es-z","disabled":"fs-z","imgCss":"gs-z"};